/* eslint-disable @typescript-eslint/no-explicit-any */
import { all } from "redux-saga/effects";
import { watcherDashboard } from "./modules/dashboard";
import { watcherLogin } from "./modules/loginSaga";
import { watcherHome } from "./modules/homeSaga";
import { watcherActivity } from "./modules/Dashboard/activitySaga";
import { watcherTransfer } from "./modules/transfers";
import { watcherEurailTicket } from "./modules/Dashboard/eurailTicketSaga";
import { watcherEurailPass } from "./modules/Dashboard/eurailPassSaga";
import { watcherVariable } from "./modules/variableSaga";

export default function* rootSaga() {
  const sagas: any[] = [
    watcherLogin(),
    watcherHome(),
    watcherDashboard(),
    watcherActivity(),
    watcherTransfer(),
    watcherEurailTicket(),
    watcherEurailPass(),
    watcherVariable(),
  ];

  yield all(sagas);
}
